var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/search-problem.5a2b2d13.png","uri@2x": __webpack_public_path__ + "static/media/search-problem.d2870a44.png","uri@3x": __webpack_public_path__ + "static/media/search-problem.775e16cb.png",
    width: 36,
    height: 36
});